export const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

export const getShortDescription = (text: string | undefined) => {
    if (text && text.length > 100) {
        return text.substring(0, 97) + "..."
    } else {
        return text
    }
}

const INVISIBLE_CHARACTERS = /[\u00AD\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF]/g

export const sanitizeSearchQuery = (value: string) =>
    value.replace(INVISIBLE_CHARACTERS, "").replace(/\s+/g, " ").trim()
